module.exports = __webpack_public_path__ + "static/media/1.6ff3fc48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/articles/1.jpg
// module id = 170
// module chunks = 0